import React from 'react';
import resourcesImage from '../../../assets/images/home_screen/resources.webp';
import GradientOutlineButton from '../../../components/atoms/GradientOutlineButton';

const Resources = () => {
  return (
    <main
      id="resources"
      className="flex flex-col md:flex-row justify-center items-end max-w-[1200px] mx-auto h-full px-4 md:px-10 py-8 md:py-18 z-10 gap-10 md:gap-20"
    >
      <div className="flex flex-col gap-2 flex-1">
        <h2 className="text-4xl md:text-5xl text-primary font-bold">
          Resources
        </h2>
        <p className="text-secondary text-lg">
          In our Resources Section, we strive to equip parents with valuable
          information and practical strategies to support their child's
          development. From insightful articles on common diagnoses to practical
          tips for home-based activities, we provide a wealth of resources to
          help parents navigate their child's journey. Discover expert guidance,
          evidence-based techniques, and empowering tools that enable you to
          actively engage in your child's progress and create meaningful
          experiences right from the comfort of your home.
        </p>
        <div className="flex gap-4 mt-4 items-center">
          <GradientOutlineButton
            text="Our Resources"
            navigateTo={'/resources'}
            isDark={false}
          />
          <GradientOutlineButton
            text="Forms"
            isDark={false}
            navigateTo={'/resources/forms'}
          />
        </div>
      </div>
      <div className="flex-1">
        <a
          href="https://www.youtube.com/@GuidepostPediatric"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={resourcesImage}
            alt="mom_baby"
            className="w-full md:w-auto md:h-[400px] object-contain"
          />
        </a>
      </div>
    </main>
  );
};

export default Resources;
